import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {put} from 'typed-redux-saga';

import {AnimalType} from 'api/gen/AnimalType';

import {animalBrowserAction} from '../action';

/**
 * Refreshes the relevant browser session after animals are added.
 *
 * @param animalType Animal-browser type whose session should be refreshed.
 * @returns The follow-up saga effects that keep the session state in sync.
 */
export function* updateAnimalSessionAfterAddition(animalType: AnimalType): SagaIterator {
    yield* put(animalBrowserAction.getAnimalsCount(animalType));

    if (animalType === 'BREEDING_FEMALES') {
        yield* put(animalBrowserAction.getCabFemales(opt({action: 'refresh'})));
    } else {
        yield* put(animalBrowserAction.getCabCalves(opt({action: 'refresh'})));
    }
}
